<template>
  <div id="app">
    <HearTop></HearTop>
    <router-view/>
    <Footer></Footer>
  </div>
</template>
<script>
import HearTop from './hearTop'
import Footer from './footer'
export default {
  components:{
    HearTop,
    Footer,
  },
}
</script>


// WEBPACK FOOTER //
// src/components/navTop/index.vue